import { DestroyRef, assertInInjectionContext, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, tap } from 'rxjs';

import { isObject } from '@core/helpers';

import { BrowserApiService } from '../common';

import { WebsocketEvents, WebsocketMessage } from './websocket.entity';
import { WebsocketClient } from './websocket.client';

function isValidMessage(message: any): message is WebsocketMessage<any> {
  return isObject(message) && 'event' in message && 'data' in message;
}

export function listenWebsocketEvents(events: WebsocketEvents, room?: string): () => void {
  assertInInjectionContext(listenWebsocketEvents);

  const destroyRef = inject(DestroyRef);
  const websocketClient = inject(WebsocketClient);
  const browser = inject(BrowserApiService);

  if(browser.isServer()) {
    return () => {};
  }

  if(room) {
    websocketClient.subscribeToRoom(room)
      .pipe( takeUntilDestroyed() )
      .subscribe();
  }

  const eventsSubscription = websocketClient.stream$
    .pipe(
      filter((message: any): message is WebsocketMessage<any> => isValidMessage(message) && !!events[message.event]),
      tap((message) => events[message.event](message.data))
    )
    .subscribe();

  const unsubscribeCallback = () => {
    eventsSubscription.unsubscribe();

    room && websocketClient
      .unsubscribeFromRoom(room)
      .subscribe();
  };

  destroyRef.onDestroy(() => unsubscribeCallback());

  return unsubscribeCallback;
}